"use client";

import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { setNextDevToolsHidden } from "@/lib/dev-tools-hide";
import { isPlatformAdmin } from "@/lib/permissions";

/**
 * Next.js injects a dev-only indicator inside <nextjs-portal> (shadow DOM) in
 * `next dev`. Hide it for everyone except platform super-admins. No-op in prod.
 */
export function DevToolsGate() {
  const { data: session, status } = useSession();
  const showDevTools =
    process.env.NODE_ENV === "development" &&
    status === "authenticated" &&
    isPlatformAdmin(session);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;
    setNextDevToolsHidden(!showDevTools);
  }, [showDevTools]);

  return null;
}
